import React from 'react'
import { Route as OriginalRoute, RouteProps } from 'react-router-dom'

import ScreenContainer from './components/ScreenContainer'

interface Props extends RouteProps {
}

const ScreenRoute: React.SFC<Props> = ({ component: RouteComponent = 'div', ...restProps }) => (
  <OriginalRoute
    {...restProps}
    render={(props) => (
      <ScreenContainer {...restProps}>
        <RouteComponent {...props} />
      </ScreenContainer>
    )}
  />
)

export default ScreenRoute
